var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageIsLoading)?_c('div',{staticClass:"authorization-layout"},[_vm._t("default")],2):_c('div',{staticClass:"loading-authorization-layout"},[_c('b-spinner',{attrs:{"label":"Spinning"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae4d358","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AuthorizationLayout.vue
// module id = null
// module chunks = 